import 'promise-polyfill/src/polyfill';
import smoothscroll from 'smoothscroll-polyfill';
require('intersection-observer');
smoothscroll.polyfill();
// import Swiper JS
import Swiper from 'swiper';
// import Swiper styles
// import 'swiper/swiper-bundle.css';

const header = document.getElementById('header');
const main = document.getElementById('main');

// header

window.onscroll = () => {
  if (window.pageYOffset >= 200) {
    header.classList.add('header__anim');
    header.style.position = 'fixed';
  } else if (window.pageYOffset === 0) {
    header.classList.remove('header__anim');
    header.style.position = 'absolute';
  }
};

//intersection observer

const iSObserversA = document.querySelectorAll('.iSObserver');
const iSObservers = Array.prototype.slice.call(iSObserversA, 0);
const options = {
  rootMargin: '-50% 0px',
};

const fadeIn = (target) => {
  target.classList.add('fadeIn');
};

const observeUse = (entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      fadeIn(entry.target);
    }
  });
};

const observer = new IntersectionObserver(observeUse, options);
iSObservers.forEach(iSObserver => {
  observer.observe(iSObserver);
});

//スムーススクロール

const paginationsA = document.querySelectorAll('a[href^="#"]');
const paginations = Array.prototype.slice.call(paginationsA, 0);
paginations.forEach(pagination => {
  pagination.addEventListener('click', e => {
    e.preventDefault();
    const targetId = e.target.hash;
    const target = document.querySelector(targetId);
    target.scrollIntoView({
      behavior: 'smooth'
    });
  });
});

// humb

const humb = document.getElementById('humb');
const navArea = document.getElementById('navArea');
const topContactUs = document.getElementById('topContactUs');
const headerNavUl = document.getElementById('headerNavUl');

humb.addEventListener('click', () => {
  if (humb.classList.contains('header__humbArea-open')) {
    humb.classList.remove('header__humbArea-open');
    navArea.classList.remove('navArea-open');
    header.classList.remove('header-bgtra');
    // document.body.classList.remove('bodyScroll');
  } else {
    humb.classList.add('header__humbArea-open');
    navArea.classList.add('navArea-open');
    header.classList.add('header-bgtra');
    // document.body.classList.add('bodyScroll');
  }
});

topContactUs.addEventListener('click', () => {
  if (headerNavUl.classList.contains('fadeIn')) {
    headerNavUl.classList.remove('fadeIn');
  } else {
    headerNavUl.classList.add('fadeIn');
  }
});



const swiperDo = () => {
  if (window.matchMedia("(max-width: 768px)").matches) {
    var swiper = new Swiper('.swiper-container', {
      navigation: {},
      slidesPerView: 1.5,
      centeredSlides: true,
      initialSlide: 1,
      spaceBetween: 20,
      loop: true,
      autoplay: {
        delay: 3000,
      },
      disableOnInteraction: true,
      breakpoints: {
        768: {}
      }
    });
  }
}

swiperDo();

// 資料
const formPage = document.getElementsByClassName('formPage');
if (formPage.length !== 0) {
    const formFirst = document.getElementsByClassName('first')[0].getElementsByTagName('label')[0];
    const formLast = document.getElementsByClassName('last')[0].getElementsByTagName('label')[0];
    formFirst.insertAdjacentHTML('beforeend', '<div class="formPage__inputImgArea"><img src="https://daieikensetsu.com/wp-content/themes/daiei/images/page/2014pol_catalog@2x.png" alt="" class="formPage__inputImg" width="408" height="204"></div>');
    formLast.insertAdjacentHTML('beforeend', '<div class="formPage__inputImgArea"><img src="https://daieikensetsu.com/wp-content/themes/daiei/images/page/catalog@2x.png" alt="" class="formPage__inputImg" width="408" height="204"></div>');
}


window.addEventListener('resize', () => {

});

window.addEventListener('load', () => {
    const catchArea = document.getElementsByClassName('topTopCont__catchArea');
    if (catchArea[0]) {
        catchArea[0].classList.add('topTopCont__catchArea-anim');
    }
    if (main) {
        const headerH = header.clientHeight;
        main.style.marginTop = `${headerH}px`;
    }
});